import { ArrowUpRight } from "lucide-react";

import hypeStackIcon from "@/assets/images/icon.png";

/**
 * The tiny plug for Hype Stack. Two faces: the full card sits at the bottom
 * of the profile rail on viewports wide AND tall enough for the whole rail to
 * fit on screen; everywhere else (phones, short desktop windows) a compact
 * pill pins to the bottom corner and the rail flows normally.
 */
export function HypeStackCard() {
  return (
    <>
      <a
        href="https://hype-stack.dev"
        target="_blank"
        rel="noreferrer"
        title="This whole site, newsletter and admin included, came from one compose command."
        className="group fixed bottom-4 right-4 z-[1001] flex items-center gap-2 rounded-full border border-border bg-gradient-to-br from-primary to-primary/85 py-2 pl-2.5 pr-3.5 text-sm font-semibold text-primary-foreground shadow-lg transition-shadow hover:shadow-xl lg:[@media(min-height:960px)]:hidden"
      >
        <span className="flex size-6 items-center justify-center rounded-full bg-primary-foreground/15 p-0.5">
          <img src={hypeStackIcon} alt="" className="max-h-full max-w-full object-contain" />
        </span>
        Built with Hype Stack
        <ArrowUpRight className="size-3.5 opacity-60 transition-opacity group-hover:opacity-100" />
      </a>

      <a
        href="https://hype-stack.dev"
        target="_blank"
        rel="noreferrer"
        className="group hidden rounded-2xl border border-border bg-gradient-to-br from-primary to-primary/85 p-4 text-primary-foreground shadow-sm transition-shadow hover:shadow-md lg:[@media(min-height:960px)]:block"
      >
        <div className="flex items-center gap-2">
          <span className="flex size-8 items-center justify-center rounded-lg bg-primary-foreground/15 p-1">
            <img src={hypeStackIcon} alt="" className="max-h-full max-w-full object-contain" />
          </span>
          <span className="font-semibold">Built with Hype Stack</span>
          <ArrowUpRight className="ml-auto size-4 opacity-60 transition-opacity group-hover:opacity-100" />
        </div>
        <p className="mt-2 text-sm leading-relaxed opacity-80">
          This whole site, newsletter and admin included, came from one compose command.
        </p>
      </a>
    </>
  );
}
